import * as React from 'react';
import {Link} from 'react-router-dom';

import type {FormattedValue} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';
import {ProgressBar} from 'shells/progress-bar/progress-bar';

import styles from './funnel-row.module.css';

export type StageInfo = {
    id: string;
    type: string;
    count: string;
    name: string;
    htmlUrl: string;
    value: FormattedValue;
};

type Props = {
    stageInfo: StageInfo;
    relativeHighestValue: number;
    filterHot: boolean;
};

export class FunnelRow extends React.PureComponent<Props> {
    render() {
        const {stageInfo, relativeHighestValue} = this.props;
        const stageInfoWidthPercent =
            relativeHighestValue === 0 ? 0 : Number(stageInfo.count) / relativeHighestValue;
        const realStageWidthPercent = Math.max(stageInfoWidthPercent, 0.01);

        const content = (
            <React.Fragment>
                <div title={stageInfo.name} className={styles.name}>
                    {stageInfo.name}
                </div>
                <div className={styles.count}>{`${stageInfo.count} leads`}</div>
                <div title={stageInfo.value.value.toLocaleString()} className={styles.value}>
                    <span>{stageInfo.value.prefix}</span>
                    <span>{stageInfo.value.formatted}</span>
                    <span>{stageInfo.value.suffix}</span>
                </div>
                <div className={styles['funnel-bar-container']}>
                    <ProgressBar
                        percentComplete={realStageWidthPercent}
                        color={this.props.filterHot ? colors.backgroundHot : colors.blue}
                    />
                </div>
            </React.Fragment>
        );

        return (
            <li className={styles['list-item-funnel-row']}>
                {/* @ts-expect-error */}
                <Link to={this.props.stageInfo.htmlUrl} className={styles.container}>
                    {content}
                </Link>
            </li>
        );
    }
}
